import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const selectedSetSlice = createSlice({
  name: "selectedSet",
  initialState: "-1",
  reducers: {
    setSelectedSet: (_state: string, action: PayloadAction<string>) => action.payload,
  },
});

const selectionSetUpdatedSlice = createSlice({
  name: "selectionSetUpdated",
  initialState: false,
  reducers: {
    setSelectionSetUpdated: (_state: boolean, action: PayloadAction<boolean>) => action.payload,
  },
});

export const { setSelectedSet } = selectedSetSlice.actions;
export const { setSelectionSetUpdated } = selectionSetUpdatedSlice.actions;

export const selectedSet = selectedSetSlice.reducer;
export const selectionSetUpdated = selectionSetUpdatedSlice.reducer;
